import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { alertIcError24px } from '@ey-xd/motif-react/assets/icons';
import { MessageParagraph, ModalHeaderContainer } from './styles/plOpportunityNameModal.styles';
import { BUTTON_TITLE } from '../../../constants/commonConstants';
import { useNavigate } from 'react-router-dom';

function NoUserFoundModal() {
  const navigate = useNavigate();

  const [showDangerModal, setShowDangerModal] = useState(true);

  const closeDangerModal = () => {
    setShowDangerModal(false);
  };

  const onOpenEyCrmClicked = () => {
    window.location.href = process.env.REACT_APP_OPPS_NAME_IFRAME_URL;
  };

  return (
    <MotifModal size="sm" variant="alt" show={showDangerModal} onClose={closeDangerModal}>
      <MotifModalHeader title="Close opportunity details modal" closeModalButton={true}>
        <ModalHeaderContainer>
          <MotifIcon style={{ color: '#F95D54', paddingRight: '10px' }} src={alertIcError24px} />
          No Opportunities to display
        </ModalHeaderContainer>
      </MotifModalHeader>
      <MotifModalBody>
        <MessageParagraph>You have no opportunities in EY CRM or Mercury.</MessageParagraph>

        <MessageParagraph>
          Please make sure you have opportunities assigned to you and under the right role in EY CRM
          or Mercury to view the Forecasting application.
        </MessageParagraph>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant="secondary" type="button" onClick={onOpenEyCrmClicked}>
          {BUTTON_TITLE.OPEN_EY_CRM}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}

export default NoUserFoundModal;
